<template>
    <div>
        <div class="p-3 mb-2 bg-primary text-white">
        {{ message }}
        </div>
    </div>
</template>

<script>
export default {
  name: "Fortune",
  data() {
    return {
      message: "Routing Page..."
    };
  }    
}
</script>
